import store  from '@/utils/store'
export const columns = (vm) =>{
    return [
        {
            type: 'index',
            width: 50,
            label: '序号',
            align:'center',
            headerAlign:'center',
        },
        {
            label:'订单号',
            prop:'outTradeNo',
            align:'left',
            headerAlign:'left',
        },
        {
            label:'账户名称',
            prop:'belongToName',
            align:'left',
            headerAlign:'left',
        },
        {
            label:'充值平台',
            prop:'belongToType',
            align:'center',
            headerAlign:'center',
            width:100,
            tooltip:true,
            render: (h, params) => {
                let text = ""
                let color = ""
                let list = store.state.conText.accountTypeList
                for(var i in list){
                   if(params.row.belongToType*1 == list[i].val*1){
                      text = list[i].title
                      color = list[i].color
                   }
                }
                console.log()
                return h('span',{style:{color:color}},text)
            }
        },
        {
            label:'充值类型',
            prop:'belongToType',
            align:'center',
            headerAlign:'center',
            width:100,
            tooltip:true,
            render: (h, params) => {
                let text = ""
                let color = ""
                let list = store.state.conText.searchrechargeListType
                for(var i in list){
                   if(params.row.rechargeType*1 == list[i].val*1){
                      text = list[i].title
                      color = list[i].color
                   }
                }
                console.log()
                return h('span',{style:{color:color}},text)
            }
        },
        {
            label:'充值金额',
            prop:'amount',
            align:'center',
            headerAlign:'center',
            width:120,
            render: (h, params) => {
                return h ('div', {}, params.row.amount+"元")
            }
        },
        {
            label:'支付金额',
            prop:'payAmount',
            align:'center',
            headerAlign:'center',
            width:120,
            render: (h, params) => {
                return h ('div', {}, params.row.payAmount+"元")
            }
        },
        {
            label:'支付方式',
            prop:'belongToType',
            align:'center',
            headerAlign:'center',
            width:100,
            tooltip:true,
            render: (h, params) => {
                let text = ""
                let color = ""
                let list = store.state.conText.rechargeListCHaong
                for(var i in list){
                   if(params.row.payType*1 == list[i].val*1){
                      text = list[i].title
                      color = list[i].color
                   }
                }
                console.log()
                return h('span',{style:{color:color}},text)
            }
        },
        {
            label:'操作人员',
            prop:'recharger',
            align:'center',
            headerAlign:'center',
            width:120
        },
        
        {
            label:'下单时间',
            prop:'createTime',
            align:'left',
            headerAlign:'left',
            width:180
            
        },
        {
            label:'充值时间',
            prop:'rechargeTime',
            align:'left',
            headerAlign:'left',
            width:180
            
        },
        
    ]
}